import isPlainObject from "lodash/isPlainObject";
import { succeeded, failed } from "../actions/VisitApi";

const VISIT_API_HEADER_FIELDS = [
  { name: "X-List-CurrentPage", type: "number" },
  { name: "X-List-TotalCount", type: "number" },
  { name: "X-List-NumPages", type: "number" },
  { name: "X-List-IsFisrtPage", type: "boolean" },
  { name: "X-List-IsLastPage", type: "boolean" },
];

function getResponseHeaders(allHeaders) {
  const headers = VISIT_API_HEADER_FIELDS.reduce((acc, field) => {
    const val = allHeaders.get(field.name);
    if (val) {
      let typedVal;
      switch (field.type) {
        case "boolean":
          typedVal = val === "true";
          break;
        case "number":
          typedVal = Number(val);
          break;
        default:
          typedVal = val;
      }
      acc[field.name] = typedVal;
    }
    return acc;
  }, {});
  return headers;
}

function getCSRFToken() {
  if (!document) {
    return null;
  }
  const token = document.querySelector('meta[name="csrf-token"]');
  if (token) {
    return token.getAttribute("content");
  }

  return null;
}

// eslint-disable-next-line no-unused-vars
export function createRequest(params, meta) {
  const { path, query, ...request } = params;
  let url = path;
  // { foo: 'bar' } => '?foo=bar'
  if (query) {
    const querySet = [];
    Object.entries(query).forEach(([key, val]) => {
      querySet.push(`${key}=${encodeURIComponent(val.toString())}`);
    });
    const hasQuery = url.includes("?");
    url += (hasQuery ? "&" : "?") + querySet.join("&");
  }
  if (!request.credentials) {
    request.credentials = "include";
  }
  // Add Content-Type header for Object body
  request.headers = request.headers || {};
  request.headers.Accept = "application/json;charset=UTF-8";
  request.headers["Accept-Charset"] = "utf-8";
  if (request.body && (isPlainObject(request.body) || Array.isArray(request.body))) {
    request.body = JSON.stringify(request.body);
    request.headers["Content-Type"] = "application/json;charset=UTF-8";
  }
  // Request normalized data
  if (!request.headers["X-Serialize-Format"]) {
    request.headers["X-Serialize-Format"] = "normalize";
  }
  // Add CSRF Token
  const csrfToken = getCSRFToken();
  if (csrfToken) {
    request.headers["X-CSRF-Token"] = csrfToken;
    request.headers["X-Requested-With"] = "XMLHttpRequest";
  }
  // Use meta params to authenticate in SSR server.
  // request.headers.append("X-Access-Token", meta.accessToken);
  return new Request(url, request);
}

// eslint-disable-next-line no-unused-vars
const visitApiMiddleware = store => next => action => {
  if (typeof action === "function") {
    throw new Error("Cannot accept function action. Please apply this middleware after Thunk middleware");
  }
  if (action.$type === "VISIT_API") {
    const req = createRequest(action);
    return (async () => {
      try {
        const res = await fetch(req);
        const headers = getResponseHeaders(res.headers);
        const payload = {
          status: res.status,
          statusText: res.statusText,
          headers,
        };
        const contentType = (res.headers.get("Content-Type") || "").split(/;\s*/)[0];
        let body;
        if (contentType === "application/json") {
          body = await res.json();
        } else {
          body = await res.text();
        }
        if (res.status === 403) {
          // Session might be expired.
          // TODO(KentoMoriwaki): Prompt to sign in again.
        } else if (res.status >= 500) {
          // Server error
          throw new Error(res.statusText);
        }
        if (res.status >= 400) {
          return failed({
            ...payload,
            body: new Error(body),
            isFailure: true,
          });
        }
        return succeeded({
          ...payload,
          body,
          isSuccess: true,
        });
      } catch (e) {
        // console.error(e);
        // TODO(KentoMoriwaki): Notify to Honeybadger.
        throw e;
      }
    })();
  }
  return next(action);
};

export default visitApiMiddleware;



// WEBPACK FOOTER //
// ./frontend/src/common/middlewares/visitApiMiddleware.js